export const CUSTOM_LIST_ALGOLIA_COOKIE = 'jbCustomListAlgolia';

export const CUSTOM_LIST_HITS_PER_PAGE = 1000;

export const CUSTOM_LIST_INDEX_NAME = 'products_jb4';

// Same base constraints as category pages. Kept here so the node:test spec
// can load these modules without the CJS commons package.
export const CUSTOM_LIST_BASE_FILTER = 'has_listable_stock:true';

export const CUSTOM_LIST_BASE_NUMERIC_FILTERS = [
  'item_availability=0',
  'visibility>1',
  'visibility<4',
];
